// extracted by mini-css-extract-plugin
export default {"CrossLinks":"CrossLinks_CrossLinks__MTM5N"};